import React from 'react';
import { Building2, Hotel, ShoppingBag, Home as HomeIcon, Heart, Store } from 'lucide-react';
import { industries, images } from '../mock';

const Industries = () => {
  const industryIcons = [
    Building2, // IT Companies, Corporate & Government Offices
    Hotel, // Hotels & Resorts
    ShoppingBag, // Malls & Commercial Complexes
    HomeIcon, // Societies & Residential Complexes
    Heart, // Hospitals & Clinics
    Store // Franchises
  ];

  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section
        className="relative h-[300px] bg-cover bg-center flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${images.industries})`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 className="text-5xl font-bold mb-4">Industries We Serve</h1>
          <p className="text-xl">Delivering workforce solutions across diverse sectors</p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Jupiter Group provides specialized manpower solutions tailored to the unique requirements of various
              industries, ensuring you get the right workforce for your specific needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => {
              const Icon = industryIcons[index];
              return (
                <div
                  key={industry.id}
                  className="bg-white p-8 rounded-lg shadow-md border border-gray-200 hover:shadow-xl hover:border-blue-300 transition-all duration-300"
                >
                  <div className="mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon className="w-8 h-8 text-blue-600" />
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{industry.title}</h3>
                  <p className="text-gray-600">{industry.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Industry Expertise */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Industry Expertise</h2>
            <p className="text-xl text-gray-600">Tailored solutions for every sector</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Skilled Workforce</h3>
              <p className="text-gray-600">
                Trained professionals with industry-specific expertise for specialized roles and technical positions.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Semi-Skilled Workforce</h3>
              <p className="text-gray-600">
                Capable personnel with basic training and experience for operational and support roles.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Unskilled Workforce</h3>
              <p className="text-gray-600">
                Reliable manpower for general tasks, maintenance, and support functions across all industries.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Compliance Focused</h3>
              <p className="text-gray-600">
                All workforce deployments ensure full compliance with PF, ESI, and minimum wage regulations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
